import useWeb3Forms from '@web3forms/react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import volunteer from '../assets/images/cause/service2.jpeg';

export default function Contact() {
    const [serverResponse, setServerResponse] = useState(null);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting, isValid }
    } = useForm({ mode: 'onChange' });

    const { submit: submitForm } = useWeb3Forms({
        access_key: process.env.REACT_APP_EMAIL_ACCESS_TOKEN,
        settings: {
            from_name: 'Tu Es Belle Foundation',
            subject: 'New Volunteer Request'
        },
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        onSuccess: (message) => {
            setServerResponse({ ok: true, message });
            reset();
            setTimeout(() => {
                setServerResponse(null);
              }, 5000);
        },
        onError: (message) => {
            setServerResponse({ ok: false, message });
            setTimeout(() => {
                setServerResponse(null);
              }, 5000);
        }
    });

  return (
    <>
    <div className="container">
        <div className="row align-items-center">
            <div className="col-md-6">
                <img src={volunteer} className="img-fluid d-block mx-auto" alt=""/>
            </div>
            <div className="col-md-6">
                <div className="p-4 rounded shadow bg-white ms-lg-5">
                    <h4>Join Our Cause!</h4>
                    <form className="mt-4" onSubmit={handleSubmit(submitForm)}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="name">
                                        Your Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        {...register('name', { required: 'Name is required.', maxLength: 80 })}
                                        type="text"
                                        className="form-control"
                                        placeholder="your full name"
                                    />
                                    {errors.name && <div className="text-danger mt-1">{errors.name.message}</div>}
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="email">
                                        Your Mail <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        {...register('email', { required: 'Email is required.', pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: "Please your a valid email",
                                        }, })}
                                        id='email'
                                        type="email"
                                        className="form-control"
                                        placeholder="your email"
                                    />
                                    {errors.email && <div className="text-danger mt-1">{errors.email.message}</div>}
                                </div> 
                            </div>

                            <div className="col-12">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="number">
                                        Contact <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        {...register('number', { required: 'Phone number is required.' })}
                                        type="text"
                                        className="form-control"
                                        placeholder="Phone number"
                                    />
                                    {errors.number && <div className="text-danger mt-1">{errors.number.message}</div>}
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="reason">
                                        Subject <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        {...register('reason', { required: 'Subject is required.' })}
                                        type="text"
                                        className="form-control"
                                        placeholder="enter subject"
                                    />
                                    {errors.reason && <div className="text-danger mt-1">{errors.reason.message}</div>}
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="body">
                                        Why you want to join our team <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        {...register('body', { required: 'Message is required.' })}
                                        rows="4"
                                        className="form-control"
                                        placeholder="your reason">
                                    </textarea>

                                    {errors.body && <div className="text-danger mt-1">{errors.body.message}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="d-grid">
                                    {serverResponse && (
                                        <div className={`alert ${serverResponse.ok ? 'alert-success' : 'alert-danger'}`} role="alert">
                                            {serverResponse.message}
                                        </div>
                                    )}
                                    <button type="submit" id="submit" name="send" className="btn btn-primary" disabled={!isValid || isSubmitting}>
                                        {isSubmitting ? 'Submitting...' : 'Submit Request'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>  
    </>
  )
}
